import { useState, useCallback } from 'react';

// Wraps the setLoading(true)/try/catch/setError/finally boilerplate repeated
// across nearly every form-submit handler in the app.
//
// Usage:
//   const { loading, error, setError, run } = useAsyncAction();
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     await run(async () => {
//       const res = await fetch(...);
//       const data = await res.json();
//       if (!res.ok) throw new Error(data.error);
//       ...success side effects...
//     });
//   };
export function useAsyncAction() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const run = useCallback(async (fn) => {
    setError('');
    setLoading(true);
    try {
      return await fn();
    } catch (err) {
      setError(err.message);
      return undefined;
    } finally {
      setLoading(false);
    }
  }, []);

  return { loading, error, setError, run };
}
